module.exports = __webpack_public_path__ + "static/media/event-services-img26.7ffd43a9.jpg";